import { render, staticRenderFns } from "./LaundryTypeForm.vue?vue&type=template&id=0b9efdbc&scoped=true"
import script from "./LaundryTypeForm.vue?vue&type=script&lang=js"
export * from "./LaundryTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9efdbc",
  null
  
)

export default component.exports